export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.21-1250.34",
  commitId: "f06e4cc0790627503f4edf03fae35e0fccc65201",
  commitTime: "2026-09-21T12:50:34.000Z",
});
